import React, { useState } from "react";

import ReviewCard from "./reviewCard";

import styles from "./styles.module.scss";

const ReviewsSlider = ({
  reviews
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length
    );
  };

  return (
    <div className="container">
      <div className={styles.ReviewsSlider}>

        <div className={`${styles.arrow} ${styles.arrowLeft}`} onClick={handlePrev}>
          <img src="/static/images/arrows/right-black.svg" alt="" />
        </div>

        <ReviewCard reviews={reviews} currentIndex={currentIndex}/>

        <div className={`${styles.arrow} ${styles.arrowRight}`} onClick={handleNext}>
          <img src="/static/images/arrows/right-black.svg" alt="" />
        </div>

      </div>
    </div>
  );
};

export default ReviewsSlider;
